import axios from "axios";
import { useState } from "react";
import { validate } from "email-validator";

enum Validation {
    EMPTY,
    INVALID,
    VALID,
    NONE
}

function isEmpty(str: string | null | undefined) {
    if (str === undefined || str === null || str.match(/^\s*$/)) return true
    return false
}

function isPhoneNumber(str: string) {
    // eslint-disable-next-line
    if (str.match(/(\(?([\d \-\)\–\+\/\(]+){6,}\)?([ .\-–\/]?)([\d]+))/)) return true
    return false
}

function Kontakt() {
    const [inputValidation, setInputValidation] = useState<Validation[]>([Validation.EMPTY, Validation.EMPTY, Validation.NONE, Validation.EMPTY, Validation.EMPTY])
    const [inputRows, setInputRows] = useState(8);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState("");

    const handleRowsChange = (e: any) => {
        if (!e) return;

        const rows = e.target.value.split("\n").length;
        if (rows >= 8) setInputRows(rows);
    }

    const handleInput = (e: any, i: number) => {
        if (!e) return;

        setInputValidation(prev => {
            switch (i) {
                case 1: prev[i] = validate(e.target.value) ? Validation.VALID : Validation.INVALID; break;
                case 2: prev[i] = !isEmpty(e.target.value) ? isPhoneNumber(e.target.value) ? Validation.VALID : Validation.INVALID : Validation.NONE; break;
                default: prev[i] = !isEmpty(e.target.value) ? Validation.VALID : Validation.INVALID;
            }
            return [...prev];
        })
    }

    const handleSubmit = async (e: any) => {
        if (!e) return;
        e.preventDefault();
        setLoading(true);
        const request = {
            name: e.target[1].value,
            email: e.target[2].value,
            tel: e.target[3].value,
            betreff: e.target[4].value,
            nachricht: e.target[5].value,
            website: ""
        };
        await axios.post(process.env.PUBLIC_URL + "/send_email.php", request)
            .then(response => {
                if (response.status === 200) {
                    setMessage("Danke für deine Nachricht! Ich werde mich schnellstmöglich bei dir melden!");
                    setSuccess(true);
                } else {
                    setMessage("Leider hat das Absenden nicht funktioniert. Bitte schreibe mir stattdessen eine E-Mail oder probiere es zu einem späteren Zeitpunkt erneut.");
                    setSuccess(false);
                }
            })
            .catch(() => {
                setMessage("Leider hat das Absenden nicht funktioniert. Bitte schreibe mir stattdessen eine E-Mail oder probiere es zu einem späteren Zeitpunkt erneut.");
                setSuccess(false);
            })
            .finally(() => window.location.href += "#notification");
        setLoading(false);
    }

    return <main className={loading ? "kontakt content-box loading" : "content-box kontakt"}>
        <p>Du möchtest mehr über mich und meine Arbeit erfahren? Du möchtest mir dein Projekt vorstellen und ein unverbindliches Gespräch über deinen zukünftigen Film führen? Dann schreib mir einfach eine <a href="mailto:info@simonadler.de">E-Mail</a> oder nutze das untenstehende Kontaktformular. Ich freue mich auf dich und bin auf dein Anliegen gespannt.</p>
        {message === "" ?
            <form onSubmit={handleSubmit} className="text-box">
                <fieldset>
                    <legend>Kontakt</legend>

                    <div className="input-group section">
                        <div className="input-stack">
                            <label htmlFor="name">Name</label>
                            <span className={"input-validation-" + inputValidation[0]}>
                                <input type="text" id="name" name="Name" required onChange={(e) => handleInput(e, 0)} />
                            </span>
                        </div>
                        <div className="input-stack">
                            <label htmlFor="email">E-Mail</label>
                            <span className={"input-validation-" + inputValidation[1]}>
                                <input type="email" id="email" name="E-Mail" required onChange={(e) => handleInput(e, 1)} />
                            </span>
                        </div>
                        <div className="input-stack" >
                            <label htmlFor="telefon">Telefonnummer</label>
                            <span className={"input-validation-" + inputValidation[2]}>
                                <input type="tel" id="telefon" name="Telefonnummer" onChange={(e) => handleInput(e, 2)} />
                            </span>
                        </div>
                    </div>

                    <div className="input-group section">
                        <label htmlFor="betreff">Betreff</label>
                        <span className={"input-validation-" + inputValidation[3]}>
                            <input type="text" id="betreff" name="Betreff" required onChange={(e) => handleInput(e, 3)} />
                        </span>
                    </div>

                    <div className="input-group section">
                        <div className="input-stack-full">
                            <label htmlFor="nachricht">Nachricht</label>
                            <span className={"input-validation-" + inputValidation[4]}>
                                <textarea id="nachricht" name="Nachricht" rows={inputRows} required onChange={(e) => { handleInput(e, 4); handleRowsChange(e) }} />
                            </span>
                        </div>
                    </div>

                    <button className="block" type="submit" name="submit" disabled={inputValidation.findIndex(v => v === Validation.INVALID || v === Validation.EMPTY) >= 0}>ABSENDEN</button>
                </fieldset>
            </form>
            :
            <div id="notification" className={success ? "success" : "error"}>{message}</div>
        }
    </main>
}

export default Kontakt;